import get from 'lodash/get';
import { getSecureGWTQueryParam } from 'utils/gwt';
import { timeout } from '@xmatters/redux/actions/session';
import { PlanType } from '@xmatters/common/constants/plans';
import { getPackageUrl } from 'utils/workflows';

export const IMPORT_WORKFLOW = 'IMPORT_WORKFLOW';
export const IMPORT_WORKFLOW_START = `${IMPORT_WORKFLOW}_START`;
export const IMPORT_WORKFLOW_SUCCESS = `${IMPORT_WORKFLOW}_SUCCESS`;
export const IMPORT_WORKFLOW_FAIL = `${IMPORT_WORKFLOW}_FAIL`;

const GET_WORKFLOW_FOR_IMPORT = 'GET_WORKFLOW_FOR_IMPORT';

export function getWorkflow(id) {
  return {
    type: GET_WORKFLOW_FOR_IMPORT,
    meta: {
      xmApi: true,
      uri: `/webapi/xm/1/plans/${id}`,
      method: 'get',
      params: {
        embed: 'permitted',
      },
    },
  };
}

function getFormData(file) {
  const formData = new FormData();
  formData.append('workflow', file);
  return formData;
}

function fetchWorkflowImport({
  file,
  packageUrl,
  descriptionOverride,
  nameOverride,
  featureToggleMap,
}) {
  let uri = `/alarmpoint/gwt/RelevanceEngineImportFileUploadServlet?${getSecureGWTQueryParam()}`;
  const request = {
    method: 'POST',
    credentials: 'same-origin',
  };
  if (file) {
    uri += '&order=0';
    uri += nameOverride ? `&name=${encodeURIComponent(nameOverride)}` : '';
    request.body = getFormData(file);
  }
  if (packageUrl) {
    request.body = JSON.stringify({
      packageUrl: getPackageUrl(featureToggleMap, packageUrl),
      name: nameOverride,
      description: descriptionOverride,
      order: 0,
    });
    request.headers = {
      Accept: 'application/json',
      'Content-Type': 'application/json',
    };
  }
  return fetch(uri, request);
}

function throwErrorIfFailed(importResult) {
  if (importResult.result !== 'success') {
    const error = new Error('Error importing workflow');
    error.json = importResult;
    throw error;
  }
}

function getWorkflowUuid(importResult) {
  const result = importResult.importedList.find(
    ({ key }) => key === 'engineImported',
  );
  const uuidValue = get(result, 'values[1].value');
  return uuidValue;
}

function getWorkflowType(importResult) {
  const result = importResult.importedList.find(
    ({ key }) => key === 'engineImported',
  );
  return get(result, 'values[2].value');
}

export const GATEWAY_TIMEOUT = 'IMPORT_GATEWAY_TIMEOUT';

export function importWorkflow(workflowCreationData) {
  return dispatch => {
    dispatch({
      type: IMPORT_WORKFLOW_START,
    });
    return fetchWorkflowImport(workflowCreationData)
      .then(response => {
        if (response.status === 401) {
          dispatch(timeout({}));
          throw new Error('Timeout error');
        } else if (response.status === 504) {
          throw new Error(GATEWAY_TIMEOUT);
        }
        return response.json();
      })
      .then(importResult => {
        throwErrorIfFailed(importResult);
        const workflowId = getWorkflowUuid(importResult);
        const workflowType = getWorkflowType(importResult);

        if (workflowType === PlanType.SYSTEM) {
          const payload = {
            ...importResult,
            workflow: {
              planType: workflowType,
              id: workflowId,
            },
          };
          dispatch({
            payload,
            type: IMPORT_WORKFLOW_SUCCESS,
          });

          return payload;
        }

        return dispatch(getWorkflow(workflowId)).then(({ payload }) => {
          const newPayload = {
            ...importResult,
            workflow: payload,
          };

          dispatch({
            type: IMPORT_WORKFLOW_SUCCESS,
            payload: newPayload,
          });
          return newPayload;
        });
      })
      .catch(error => {
        dispatch({
          type: IMPORT_WORKFLOW_FAIL,
          error,
        });
        throw error;
      });
  };
}
